import React from 'react';
import ReactDOM from 'react-dom';
import {ISettingsAppModel} from './model/appModel';
import config from './service/config';
import './static/css/index-embed.less';
import StateProvider from './context/stateProvider';
import {BrowserRouter} from 'react-router-dom';
import Settings from './component/settings/Settings';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';

export default (model: ISettingsAppModel) => {
   const settingsRoot = document.getElementById('settings-root');

   document.body.classList.add('app-body');

   config.initSettings(model);

   ReactDOM.render(
      <DndProvider backend={HTML5Backend}>
         <BrowserRouter>
            <StateProvider>
               <Settings />
            </StateProvider>
         </BrowserRouter>
      </DndProvider>,
      settingsRoot
   );
};